import { CellProperties } from 'handsontable/settings';
import { CellData } from '../../../../../common/table/TableTypes';
import { set } from 'lodash';
import { getRawTextFromCellContentString } from '../../../../../common/table/utils/tableCellContentStringUtils';

// TODO - Should this be changed to select between rows and columns?
/**
 * Gets the cell data from the provided cell metas up to the specified row and column limits.
 */
export const getTableCellData = (cellMetas: CellProperties[], toRow: number, toCol: number): CellData[][] => {
    const data: CellData[][] = [];

    cellMetas.forEach((cellMeta) => {
        const { row, col, cellData } = cellMeta || {};
        if (cellData && row < toRow && col < toCol) set(data, [row, col], cellData);
    });

    return data;
};

/**
 * Gets the value that will be visible to the user, even if the cell contains a formula.
 */
export const getTableCellCalculatedValue = (cellData: CellData | undefined): string | number => {
    if (!cellData) return '';

    // If the cell has a calculated result value (e.g., from a formula), return that
    if (cellData.resultValue) return cellData.resultValue;

    if (!cellData.value) return '';

    return getRawTextFromCellContentString(cellData.value);
};
